import { Tabs } from "../components/ui/tabs";
export default Tabs;